'use strict';
import $ from 'jquery';

export default class M163 {
  static init() {
    $('.module-m163').each((index, el) => {
      new M163($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.on('click', '.opener', this.onClick.bind(this));
  }

  onClick(e) {
    const i = $(e.currentTarget).data('item-id');
    this.el.find('.module-m163-image-container').removeClass('active');
    this.el.find('.module-m163-image-container:nth-child(' + (i + 1) + ')').addClass('active');
  }
}
